module.exports = __webpack_public_path__ + "img/springroll_done.848e5792.jpg";